<template>
  <div v-show="isShow" class="c-header-header-mobile-fixed">
    <div class="c-header-header-mobile-fixed__search-input">
      <search-input-mobile
        @search-focus="handleSearchFocus"
      ></search-input-mobile>
    </div>

    <transition name="slidein">
      <div class="c-header-header-mobile-fixed__main-row" v-show="isScrollUp">
        <button
          type="button"
          @click="$emit('menu-button-clicked')"
          class="c-header-header-mobile-fixed__button-menu"
        >
          <i class="icon-menu"></i>
        </button>

        <ul class="c-header-header-mobile-fixed__link-list">
          <li class="c-header-header-mobile-fixed__item">
            <icon-button
              :href="routes.root"
              icon-name="home"
              size="small"
              text="トップ"
            ></icon-button>
          </li>

          <li class="c-header-header-mobile-fixed__item">
            <icon-button
              :href="routes.fav"
              icon-name="heart-outline"
              size="small"
              text="お気に入り"
            ></icon-button>
          </li>

          <li class="c-header-header-mobile-fixed__item">
            <icon-button
              :href="routes.coordinates"
              icon-name="book"
              size="small"
              text="コーディ<br>ネート"
            ></icon-button>
          </li>

          <li class="c-header-header-mobile-fixed__item">
            <icon-button
              :href="routes.categoryList"
              icon-name="sofa"
              size="small"
              text="カテゴリ"
            ></icon-button>
          </li>

          <li class="c-header-header-mobile-fixed__item">
            <button-cart
              :cart-count="cartCount"
              :href="routes.cart"
              show-text
              size="small"
            ></button-cart>
          </li>

          <li class="c-header-header-mobile-fixed__item">
            <icon-button
              :href="accountLinkHref"
              icon-name="man"
              size="small"
              :text="accountLinkText"
            ></icon-button>
          </li>
        </ul>
      </div>
    </transition>
  </div>
</template>

<script>
import ButtonCart from '~/js/components/header/buttonCart'
import IconButton from '~/js/components/header/iconButton'
import SearchInputMobile from '~/js/components/header/searchInputMobile'

export default {
  name: 'ComponentHeaderHeaderMobileFixed',
  components: {
    ButtonCart,
    IconButton,
    SearchInputMobile,
  },
  props: {
    accountName: { type: String, default: '' },
    cartCount: { type: Number, default: 0 },
    routes: {
      type: Object,
      default: () => {
        return {}
      },
    },
    threshold: { type: Number, default: 0 },
  },
  data() {
    return {
      isShow: false,
      isScrollUp: false,
    }
  },
  computed: {
    accountLinkText() {
      return this.accountName ? `${this.accountName}様` : 'ログイン'
    },
    accountLinkHref() {
      return this.accountName ? this.routes.mypage : this.routes.login
    },
  },
  created() {
    window.addEventListener('scroll', () => {
      const threshold = this.threshold || 150
      this.isShow = window.pageYOffset >= threshold
      const newPageYOffset = window.pageYOffset
      this.isScrollUp = this.oldPageYOffset > newPageYOffset
      this.isShow = newPageYOffset >= threshold
      this.oldPageYOffset = newPageYOffset
    })
  },
  mounted() {
    this.$emit('header-mounted', { height: this.$el.clientHeight })
  },
  methods: {
    handleSearchFocus() {
      this.$emit('search-button-clicked')
    },
  },
}
</script>

<style lang="scss" scoped>
@use '~/scss/generic/variables';

.c-header-header-mobile-fixed {
  left: 0;
  margin: auto;
  position: fixed;
  right: 0;
  top: 0;

  &__search-input {
    background-color: #fff;
    padding: 8px variables.$padding-side-mobile;
    position: relative;
    z-index: 1;
  }

  &__main-row {
    background-color: #fff;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 8px variables.$padding-side-mobile;
    position: relative;
    transition: opacity 0.3s, transform 0.3s;
    width: 100%;
    z-index: 0;

    &.slidein-enter-from,
    &.slidein-leave-to {
      opacity: 0;
      transform: translateY(-100%);
    }
  }

  &__button-menu {
    font-size: 22px;
    padding: 4px;
    margin-right: 10px;
  }

  &__link-list {
    display: flex;
    justify-content: space-between;
    flex-grow: 1;
  }

  &__item {
    flex: 1;
    text-align: center;
  }
}
</style>
